"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SourceMapMode_1 = require("../../enums/source-map/SourceMapMode");
exports.SourceMapModeSanitizer = (value) => {
    const isCorrectSourceMapMode = Object
        .keys(SourceMapMode_1.SourceMapMode)
        .some((key) => {
        return SourceMapMode_1.SourceMapMode[key] === value;
    });
    if (!isCorrectSourceMapMode) {
        throw new ReferenceError('Invalid value of `--source-map-mode` option');
    }
    return value;
};
